// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hl6J","field":"styles_field__2fB9D","fieldCol":"styles_fieldCol__U8oUQ","diffCol":"styles_diffCol__2VxYY","diff":"styles_diff__agfoj"};